<template>
  <div class="view">
    <h1 class="u-visually-hidden">Théâtre de liège</h1>
    <div class="container">
      <template>
        <h2 class="h1">Dernières actualités</h2>
        <news-slider
          :loading="slidesLoading"
          :slides="slides"
        />
      </template>
      <h2 class="h1">Prochainement dans votre théâtre</h2>
      <events
        :date="date"
        :dates="dates"
        :datesDisabled="datesDisabled"
        :category="category"
        :categories="categories"
        :events="events"
        :loading="loading"
        @filter="onFilter"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import NewsSlider from '@/components/partials/NewsSlider.vue';
import Events from '@/components/partials/Events.vue';

export default {
  components: {
    Events,
    NewsSlider
  },
  beforeMount() {
    if (this.$store.state.news.items.length === 0) {
      this.$store.dispatch('news/get');
    }

    if (this.categories.length === 0) {
      this.$store.dispatch('events/categories');
    }

    if (this.events.length === 0) {
      this.$store.dispatch('events/next');
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  data() {
    return {
      scroll: this.onScroll.bind(this)
    };
  },
  computed: {
    noMore() {
      return this.$store.state.events.noMore && this.$store.state.events.noMoreStream;
    },
    date() {
      return this.$store.state.events.date;
    },
    dates() {
      return this.$store.state.events.dates;
    },
    datesDisabled() {
      return this.$store.state.events.category && this.$store.state.events.category.id === 'streams';
    },
    category() {
      return this.$store.state.events.category;
    },
    categories() {
      return this.$store.state.events.categories;
    },
    events() {
      const { category } = this.$store.state.events;
      const { attractions, streams } = this.$store.state.events;
      let items = attractions.concat(streams);

      if (!category) {
        items = items.filter(event => {
          if (!event.data.categories) {
            return true;
          }

          const categories = event.data.categories.map(cat => cat.label);
          const index = categories.indexOf('Restaurant');
          return index < 0;
        });

        // eslint-disable-next-line
        items.sort(function(a, b) {
          return new Date(a.date.start) - new Date(b.date.start);
        });
      }

      return items;
    },
    loading() {
      return this.$store.state.events.requests !== 0;
    },
    slides() {
      /* eslint-disable */
      const today = moment();
      const todayReverse = moment().format('YYYYMMDD');

      // Tickets
      // -----------------------------------------------------------------------------
      let tickets = [];

      if (this.$store.state.profile.pref.reminder) {
        tickets = [...this.$store.state.profile.orders.items];

        // Order tickets by date
        tickets.sort(function(a,b) {
          return new Date(a.date.full) - new Date(b.date.full);
        });

        // Filter tickets : ticket is passed or is too far in the futur (1 week)
        tickets = tickets.filter(ticket => {
          const diff = moment(ticket.date.full).diff(today);
          return diff > 0 && diff < 604800000;
        });

        // Only get the first element
        tickets = tickets.filter((ticket, index) => index === 0);

        // Format ticket
        tickets = tickets.map(ticket => {
          return {
            id: ticket.attractionid,
            isTicket: true,
            stream: ticket.stream,
            title: ticket.title,
            date: moment(ticket.date.full).format('[Le] DD.MM.YYYY'),
            picture: {
              src: ticket.picture,
              src2x: ticket.picture,
              alt: ticket.title
            }
          };
        });
      }

      // News
      // -----------------------------------------------------------------------------
      const news = this.$store.state.news.items.filter((n, index) => index < 5);
      const newsOfToday = [];
      const newsOfBefore = [];

      // Split news in 2 array
      for (let i = 0; i < news.length; i++) {
        const n = news[i];
        if (n.dateReverse === todayReverse) {
          newsOfToday.push(n);
        } else {
          newsOfBefore.push(n);
        }
      }

      // Like events
      // -----------------------------------------------------------------------------
      const likedEvents = this.$store.state.profile.events;
      const ticketEventId = tickets.length > 0 ? tickets[0].id : null;
      // Get event if event not ticket
      let events = likedEvents.filter(event => !ticketEventId || event.id !== ticketEventId);

      // Filter events to remove passed events
      events = events.filter(event => {
        const { start, end } = event.date;

        if (end) {
          return moment(end).diff(today) > 0;
        }

        return moment(start).diff(today) > 0;
      });

      // events.reverse();
      events.sort(function(a,b) {
        return new Date(a.date.start) - new Date(b.date.start);
      });

      // Format events for slider
      events = events.map(event => {
        const { start, end } = event.date;
        const sameDay = start === end || !end;

        return {
          isEvent: true,
          sameDay,
          id: event.id,
          title: event.title,
          date: sameDay ? `Le ${moment(start).format('DD.MM.YYYY')}` : `Du ${moment(start).format('DD.MM')} au ${moment(end).format('DD.MM.YYYY')}`,
          dateReverse: sameDay ? moment(start).format('YYYYMMDD') : moment(end).format('YYYYMMDD'),
          picture: {
            src: event.picture,
            src2x: event.picture,
            alt: event.title
          }
        }
      });

      let slides = tickets.concat(newsOfToday);
      slides = slides.concat(events);
      slides = slides.concat(newsOfBefore);

      return slides;
    },
    slidesLoading() {
      return this.$store.state.news.requests !== 0 || this.$store.state.profile.requestsEvents !== 0;
    }
  },
  methods: {
    onScroll() {
      const { scrollY, innerHeight } = window;
      const height = document.body.clientHeight;
      const scroll = scrollY + innerHeight;

      if (scroll >= height - 80) {
        if (!this.loading && !this.noMore) {
          this.$store.dispatch('events/next');
        }
      }
    },
    onFilter({ event, type }) {
      if (type === 'category') {
        this.$store.commit('events/updateCategory', event);

        if (event && event.id === 'streams') {
          this.$store.commit('events/updateDate', null);
        }
      }

      if (type === 'date') {
        this.$store.commit('events/updateDate', event);
      }

      this.$store.commit('events/updateNoMore', false);
      this.$store.commit('events/updateNoMoreStream', false);
      this.$store.commit('events/setItems', { type: 'attractions', items: [] });
      this.$store.commit('events/setItems', { type: 'streams', items: [] });
      this.$store.dispatch('events/next');
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  background-color: $black;

  .slider {
    @include margin(20px null 30px);
  }

  .loader {
    @include padding(30px null);
  }
}
</style>
